import Text from './text/index';
import Image from './image/index';
import Video from './video/index';
import Quote from './quote/index';
import Buttons from './buttons/index';
import List from './list/index';
import Highlights from './highlights/index';
import Rating from './rating/index';
import Vehicles from './vehicles/index';
import USPs from './usps/index';
import Maps from './maps/index';
import Searchbox from './searchbox/index';
import Searchslider from './searchslider/index';
import Company from './company/index';
import LatestPosts from './latest-posts/index';
import Form from './form/index';
import Modal from './modal/index';
import Autochat from './autochat/index';
import Static from './static/index';
import Share from './share/index';
import SplitBlock from './split-block/index'; // @TODO this can be removed right?
import Logos from './logos/index'; // @TODO this can be removed right?
import Faquestions from './faquestions/index';
import Reviews from './reviews/index';
import Employee from './employee/index';
import Icon from './icon/index';
import Labels from './labels/index';
import OpeningHours from './opening-hours/index';

export default {
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_TEXT: Text,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_IMAGE: Image,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_VIDEO: Video,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_QUOTE: Quote,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_BUTTONS: Buttons,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_LIST: List,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_MAPS: Maps,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_HIGHLIGHTS: Highlights,
  STRAPI__COMPONENT_PAGEBUILDER_BLOCKS_ICON: Icon,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_VEHICLES: Vehicles,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_SEARCHBOX: Searchbox,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_SEARCHSLIDER: Searchslider,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_FORM: Form,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_RATING: Rating,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_RATING: Rating,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_USPS: USPs,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_MAPS: Maps,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_COMPANY: Company,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_COMPANY: Company,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_LATEST_POSTS: LatestPosts,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_SHARE: Share,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_STATIC: Static,
  STRAPI__COMPONENT_PAGEBUILDER_INTERACTIONS_MODAL: Modal,
  STRAPI__COMPONENT_PAGEBUILDER_INTERACTIONS_AUTOCHAT: Autochat,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_SPLIT_BLOCK: SplitBlock,
  STRAPI__COMPONENT_PAGEBUILDER_STATIC_LOGOS: Logos,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_FAQUESTIONS: Faquestions,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_REVIEWS: Reviews,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_EMPLOYEE: Employee,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_LABELS: Labels,
  STRAPI__COMPONENT_PAGEBUILDER_RELATION_OPENING_HOURS: OpeningHours,
};
